import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { observable, action } from 'mobx';
import stores from 'cd-eft/models/Stores';

const setStore = stores.AppStore.surveyEngineeringStore;

export class SOCrossslopeVM {
  @observable props;
  constructor(props: any) {
    this.props = props;
  }

  //for checkboxes
  @observable checkboxes: Array<number> = [];

  @action.bound toggleCheckbox(e) {
    const value = Number(e.target.value);
    if (e.target.checked) {
      this.checkboxes = [...this.checkboxes, value];
    } else {
      const items = this.checkboxes.filter((p) => !(p === value));
      this.checkboxes = items;
    }
  }

  //delete button onClick functionality
  @action.bound deleteCSStationHandler(event: any) {
    event.preventDefault();
    this.checkboxes.forEach((e) => {
      setStore.stationOffsetObject.crossSlopeStations[e].editing_status = 'delete';
      setStore.stationOffsetObject.alignmentStations[e].editing_status = 'delete';
    });
    setStore.stationOffsetObject.crossSlopeStations = setStore.stationOffsetObject.crossSlopeStations.filter(
      (item) => item.editing_status !== 'delete'
    );
    setStore.stationOffsetObject.alignmentStations = setStore.stationOffsetObject.alignmentStations.filter(
      (item) => item.editing_status !== 'delete'
    );
    this.checkboxes = [];
  }

  // add Row
  @action.bound addRow(i: number) {
    this.checkboxes = [];
    setStore.stationOffsetObject.crossSlopeStations.splice(i, 0, setStore.initialCrossSlopeStation);
    setStore.stationOffsetObject.alignmentStations.splice(i, 0, setStore.initialAlignmentStation);
  }

  // for graph
  @observable plotData = {};
  @observable targetDivID = 'so-graph-div';
  @observable windowOptions = {
    margins: { top: 10, right: 60, bottom: 40, left: 60 },
    height: 450,
    axis: { x: 'Distance (ft)', y: 'Elevation (ft)' },
    curveType: 'curveLinear',
  };

  // update all crossSlopeStations in Store
  @action.bound updateAllcrossSlopeStations(e: any) {
    const value = +e.target.value;
    const name = e.target.name;
    setStore.stationOffsetObject.crossSlopeStations.forEach((item) => {
      item[name] = value;
    });
    setStore.initialCrossSlopeStation[name] = value;
  }

  @action.bound updateHiElevation(e: any) {
    const value = e.target.value;
    const i = e.target.getAttribute('data-i');
    setStore.stationOffsetObject.crossSlopeStations[i].hiElevation = value;
    this.setAlignmentZ(i, value);
    this.refillPlotData(setStore.stationOffsetObject.crossSlopeStations[i]);
  }

  @action.bound updatecrossSlopeStationOffsetZ(e: any) {
    const value = e.target.value;
    const i = e.target.getAttribute('data-i');
    const j = e.target.getAttribute('data-j');
    setStore.stationOffsetObject.crossSlopeStations[i].crossSlopeStationOffsets[j].z = value;
    if (Number(j) === 0) {
      this.setAlignmentZ(i, value);
    }
    this.refillPlotData(setStore.stationOffsetObject.crossSlopeStations[i]);
  }

  @action.bound updateCrossSlopeStationSlope(e: any) {
    const value = e.target.value;
    const i = e.target.getAttribute('data-i');
    const j = e.target.getAttribute('data-j');
    setStore.stationOffsetObject.crossSlopeStations[i].crossSlopeStationOffsets[j].crossSlopeStationSlope = value;
    this.refillPlotData(setStore.stationOffsetObject.crossSlopeStations[i]);
  }

  @action.bound setAlignmentZ(i, value) {
    setStore.stationOffsetObject.alignmentStations[i].z =
      setStore.stationOffsetObject.crossSlopeStations[i].offsetType === 'TYPE_ROD'
        ? setStore.stationOffsetObject.crossSlopeStations[i].hiElevation - value
        : value;
  }

  @action.bound updateDistanceHandler(e: any) {
    const value = e.target.value;
    const index = e.target.getAttribute('data-i');
    setStore.stationOffsetObject.crossSlopeStations[index].stationDistance = value;
    setStore.stationOffsetObject.alignmentStations[index].stationDistance = value;
    setStore.stationOffsetObject.alignmentStations[index].distance = value;
    setStore.stationOffsetObject.alignmentStations[index].y =
      Number(setStore.stationOffsetObject.beginningY) + Number(value);
    setStore.stationOffsetObject.alignmentStations[index].stationName = Math.round(value);
    this.refillPlotData(setStore.stationOffsetObject.crossSlopeStations[index]);
  }

  @action.bound setUphills(e: any) {
    setStore.stationOffsetObject.crossSlopeStations.forEach((station) => {
      station.uphillsTo = e.target.value;
    });
    setStore.initialCrossSlopeStation.uphillsTo = e.target.value;
  }

  @action.bound setType(e: any) {
    setStore.stationOffsetObject.crossSlopeStations.forEach((station) => {
      station.offsetType = e.target.value;
    });
    setStore.initialCrossSlopeStation.offsetType = e.target.value;
  }

  @action.bound setEntryMode(e: any) {
    setStore.stationOffsetObject.crossSlopeStations.forEach((station) => {
      station.entryMode = e.target.value;
    });
    setStore.stationOffsetObject.crossSlopeStations[0].entryMode === 'PERCENTSLOPE'
      ? this.setupPercentSlope()
      : this.setupSingleShot();
    setStore.initialCrossSlopeStation.entryMode = e.target.value;

    if (setStore.stationOffsetObject.crossSlopeStations[0].entryMode === 'SINGLESHOT') {
      setStore.stationOffsetObject.crossSlopeStations.forEach((station) => {
        station.crossSlopeStationOffsets[1].crossSlopeStationOffset =
          setStore.stationOffsetObject.crossSlopeStations[0].singleShotOffset;
      });
    }
  }

  @action.bound setupSingleShot() {
    const singleShotOffset = {
      crossSlopeStationOffset: setStore.stationOffsetObject.crossSlopeStations[0].singleShotOffset,
      z: 0,
      crossSlopeStationSlope: 0,
      editingStatus: 'add',
    };
    setStore.stationOffsetObject.crossSlopeStations.forEach((station) => {
      station.crossSlopeStationOffsets.push(singleShotOffset);
    });
    setStore.initialCrossSlopeStation.crossSlopeStationOffsets.push(singleShotOffset);
  }

  @action.bound setupPercentSlope() {
    if (setStore.stationOffsetObject.crossSlopeStations[0].crossSlopeStationOffsets.length > 1) {
      setStore.stationOffsetObject.crossSlopeStations.forEach((station) => {
        station.crossSlopeStationOffsets.pop();
        // station.singleShotOffset = 0;
      });
      if (setStore.initialCrossSlopeStation.crossSlopeStationOffsets.length > 1) {
        setStore.initialCrossSlopeStation.crossSlopeStationOffsets.pop();
      }
    }
  }

  @action.bound addCSStationHandler(e: any) {
    e.preventDefault();
    MessageCenter.clearMessages();
    const newStation = { ...setStore.initialCrossSlopeStation };
    const stations = [...setStore.stationOffsetObject.crossSlopeStations];
    const newDistance = stations[stations.length - 1].stationDistance + stations[0].stationStep;
    newStation.stationDistance = newDistance;
    if (stations[0].entryMode === 'SINGLESHOT') {
      newStation.singleShotOffset = stations[0].singleShotOffset;
    }
    setStore.stationOffsetObject.crossSlopeStations = [...stations, { ...newStation }];
    // new AlignmentStation
    const newAlignmentStation = { ...setStore.initialAlignmentStation };
    newAlignmentStation.stationDistance = newDistance;
    newAlignmentStation.distance = newDistance;
    newAlignmentStation.y = Number(setStore.stationOffsetObject.beginningY) + Number(newDistance);
    newAlignmentStation.stationName = Math.round(newDistance);
    setStore.stationOffsetObject.alignmentStations.push({ ...newAlignmentStation });
  }

  @action.bound onFocusHandler(e: any) {
    const index = e.target.getAttribute('data-i');
    const station = setStore.stationOffsetObject.crossSlopeStations[index];
    this.refillPlotData(station);
  }

  @action.bound onBlurHandler(e: any) {
    if (e.target.value === '') {
      e.target.value = '0';
    }
  }

  @action.bound refillPlotData(station) {
    const stationName = `Station ${station.stationDistance}`;
    const elevation = Number(station.crossSlopeStationOffsets[0].z);
    const hi = station.hiElevation - elevation;
    this.plotData = {};
    this.plotData[stationName] = [];

    if (station.entryMode === 'PERCENTSLOPE') {
      const slope = Number(station.crossSlopeStationOffsets[0].crossSlopeStationSlope);
      if (station.offsetType === 'TYPE_ELEVATION') {
        this.plotData[stationName].push([-station.slopeWidth, elevation + station.slopeWidth * slope * 0.01]);
        this.plotData[stationName].push([0, elevation]);
        this.plotData[stationName].push([station.slopeWidth, elevation - station.slopeWidth * slope * 0.01]);
      }
      if (station.offsetType === 'TYPE_ROD') {
        // console.log(station.hiElevation, elevation);
        this.plotData[stationName].push([-station.slopeWidth, hi + station.slopeWidth * slope * 0.01]);
        this.plotData[stationName].push([0, hi]);
        this.plotData[stationName].push([station.slopeWidth, hi - station.slopeWidth * slope * 0.01]);
      }
    }
    if (station.entryMode === 'SINGLESHOT') {
      const slope =
        ((Number(station.crossSlopeStationOffsets[0].z) - Number(station.crossSlopeStationOffsets[1].z)) /
          station.singleShotOffset) *
        100;

      if (station.offsetType === 'TYPE_ELEVATION') {
        this.plotData[stationName].push([-station.slopeWidth, elevation + station.slopeWidth * slope * 0.01]);
        station.crossSlopeStationOffsets.map((el) =>
          this.plotData[stationName].push([el.crossSlopeStationOffset, Number(el.z)])
        );
        this.plotData[stationName].push([station.slopeWidth, elevation - station.slopeWidth * slope * 0.01]);
      }
      if (station.offsetType === 'TYPE_ROD') {
        this.plotData[stationName].push([-station.slopeWidth, hi - station.slopeWidth * slope * 0.01]);
        station.crossSlopeStationOffsets.map((el) =>
          this.plotData[stationName].push([el.crossSlopeStationOffset, station.hiElevation - Number(el.z)])
        );
        this.plotData[stationName].push([station.slopeWidth, hi + station.slopeWidth * slope * 0.01]);
      }
    }
  }
}
